// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see TransfersViewViewContentEvent
 */
export var TransfersViewViewContent = function () { return ({
    name: "Transfers View ViewContent",
    parameters: {
        cdf_entity: "Transfers",
        cdf_action: "View",
    }
}); };
/**
 * @see TransfersTapWhatsTheDifferenceEvent
 */
export var TransfersTapWhatsTheDifference = function () { return ({
    name: "Transfers Tap WhatsTheDifference",
    parameters: {
        cdf_entity: "Transfers",
        cdf_action: "Tap",
    }
}); };
/**
 * @see TransfersTapHowToMakeATransferEvent
 */
export var TransfersTapHowToMakeATransfer = function (_a) {
    var section = _a.section;
    return ({
        name: "Transfers Tap HowToMakeATransfer",
        parameters: {
            cdf_entity: "Transfers",
            cdf_action: "Tap",
            section: section !== undefined && section !== null ? section.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TransfersTapOrderCashCardEvent
 */
export var TransfersTapOrderCashCard = function () { return ({
    name: "Transfers Tap OrderCashCard",
    parameters: {
        cdf_entity: "Transfers",
        cdf_action: "Tap",
    }
}); };
/**
 * @see TransfersTapGoToCardsEvent
 */
export var TransfersTapGoToCards = function () { return ({
    name: "Transfers Tap GoToCards",
    parameters: {
        cdf_entity: "Transfers",
        cdf_action: "Tap",
    }
}); };
/**
 * @see TransfersTapTooltipEvent
 */
export var TransfersTapTooltip = function () { return ({
    name: "Transfers Tap Tooltip",
    parameters: {
        cdf_entity: "Transfers",
        cdf_action: "Tap",
    }
}); };
/**
 * @see TransfersTapCopyNumberEvent
 */
export var TransfersTapCopyNumber = function (_a) {
    var section = _a.section, type = _a.type;
    return ({
        name: "Transfers Tap CopyNumber",
        parameters: {
            cdf_entity: "Transfers",
            cdf_action: "Tap",
            section: section !== undefined && section !== null ? section.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
